import { HttpClient } from '@angular/common/http';
import { ElementRef, Injectable, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})



export class AppServiceService {
  loginType:string;
  targetReferrer:string;
  isMoeLogin:boolean = false;
  hideMenuSide:boolean = false;
  hideQuestions:boolean = false;
  hideFooter:boolean = false;
  mobileOtp:string=''
  nowUrl:string;
  componentName:string='';
  resetUrl:string;
  listComponentName : { [key: string]: string } = {
    loginViaSms: "login-via-sms-component",
    loginViaOtp: "login-via-otp-component",
    loginViaPassword:"login-via-password-component",
    loginViaOtpMoe:"login-via-otp-moe-component",
    loginViaPasswordMoe:"login-via-password-moe-component"
}
  

  private redirect = new Subject<any>();
  redirect$ = this.redirect.asObservable();

  private logoutPopup = new Subject<any>();
  logoutPopup$ = this.logoutPopup.asObservable();

 focusAfterLogoutPopup(){
  this.logoutPopup.next();
 }
 private fieldFilled = new BehaviorSubject<boolean>(false);
 fieldFilled$ = this.fieldFilled.asObservable();

 setFieldStatus(isFilled: boolean): void {
   this.fieldFilled.next(isFilled);
 }
  redirectTourl() {
    this.redirect.next();
  }

  constructor(private http: HttpClient) { }

  doReset(){    
    switch (window['_loginType']) {
      case window['_loginTypeUsernamePassword']: {
          this.resetUrl = window['_loginMethodUsernameSMSOTPURL'];
          break;
      }
      case window['_loginTypeUsernameSMSOTP']:
      case window['_loginTypeOTPOnly']:
        case window['_loginTypeMOEUserPassSMS']:  {
        this.resetUrl = window['_loginMethodUsernamePasswordURL'];
        break;
      }
      default:
        this.resetUrl  = window.location.href;
    }

    this.http.post(this.resetUrl, {})
    .subscribe().add(() => {
        window.location.reload();
      });
  }

  }


